import { useMutation } from "@tanstack/react-query";
import { useAxios, useApiResponseParser } from "../";

export interface ILeadSource {
    Id: string;
    Name: string;
    Description?: string;
    IsActive?: boolean;
}

export interface ILead {
    Id?: string;
    LeadSourcesId: string;
    Name?: string;
    ProjectId?: string | null;
}

export default function useLead() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useListLeadSources() {
        return useMutation({
            mutationFn: () => axiosPrivate.get(`/v1/lead/lead-source/list`).then(parseSuccessResponseData),
        });
    }

    function useCreateLead() {
        return useMutation({
            mutationFn: (parameters: ILead) =>
                axiosPrivate.post(`/v1/lead/create`, parameters).then(parseSuccessResponseData),
        });
    }

    return { useListLeadSources, useCreateLead };
}
